import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/events'),
            roles: ['administrator', 'supervisor'],
            component: SettingsContent,
            props: {
                headerTitle: 'EVENTS_SETTINGS.TITLE',
                icon: 'flash-settings',
                showBackButton: true,
                backUrl: { name: 'settings_applications' },
                showNewButton: false,
            },
            children: [
                {
                    path: '',
                    name: 'events_settings_index',
                    component: Index,
                    roles: ['administrator', 'supervisor'],
                },
            ],
        },
    ],
};
